import { render, staticRenderFns } from "./land-about.vue?vue&type=template&id=37cb8473"
import script from "./land-about.vue?vue&type=script&lang=js"
export * from "./land-about.vue?vue&type=script&lang=js"
import style0 from "./land-about.vue?vue&type=style&index=0&id=37cb8473&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports